import { currentLanguage } from 'utils/currentLanguage';

const getBasicAuth = () => {
  const href = window.location.href;

  switch (true) {
    case href.match(/preprod-.*-d8\.valeoservice\.systems/) !== null:
      return {
        Authorization:
          'Basic YWR5YXhkZXZlbG9wcGVyczozUDBxdXV2YTNVbktRcVZ3eVlJcQ==',
      };
    default:
      return {};
  }
};

/**
 * We can remove this function by setting url as global variable on web4u part and use after build.
 */
const getBackendUrl = () => {
  const href = window.location.href;

  switch (true) {
    case href.match(/localhost/) !== null:
    case href.match(/dev\..*\.valeoservice\.systems/) !== null:
      return 'https://dev.api.techassist.valeoservice.systems/';
    case href.match(/staging\..*\.valeoservice\.systems/) !== null:
      return 'https://staging.api.techassist.valeoservice.systems/';
    default:
      return 'https://api.techassist.valeoservice.systems/';
  }
};

const getTecdocUrl = () => {
  const href = window.location.href;

  switch (true) {
    case href.match(/localhost/) !== null:
    case href.match(/dev\..*\.valeoservice\.systems/) !== null:
      return 'https://dev.api.techassist.valeoservice.systems/api/v1/';
    case href.match(/staging\..*\.valeoservice\.systems/) !== null:
      return 'https://staging.api.techassist.valeoservice.systems/api/v1/';
    default:
      return 'https://api.techassist.valeoservice.systems/api/v1/';
  }
};

export const regexMatchWord = (escapedValue) => {
  return new RegExp('(?=^|$|[^\\p{L}])' + escapedValue, 'i');
};

export const getIsValeoBrand = (valeoIDs, id) => valeoIDs.indexOf(id) !== -1;

const isMexican = currentLanguage === 'es-mx';
const isChina = currentLanguage === 'zh-hans';
const endpointSuffix = isMexican ? 'td/mx/' : 'td/';

export const tecDocUrl = getTecdocUrl() + endpointSuffix;
export const catDataUrl = getTecdocUrl() + 'carplate';
export const backendUrl = getBackendUrl();
export const basicAuth = getBasicAuth();
// export const PROVIDER_ID = 1000;
export const PROVIDER_ID = isMexican ? 22127 : 20988;
// [21, 19] are IDs of Valeo Brand and SWF Brand. The order is important here.
// [4385] is ID of Valeo China Brand.
// [4322] is ID of Valeo Mexico Brand.
export const VALEO_BRANDS =
  isChina || isMexican ? [4385, 4322, 21, 19] : [21, 19];
// [54] is the ID of FTE Brand.
export const OTHER_BRANDS = [54];



// WEBPACK FOOTER //
// ./src/utils/constantsHelper.js